import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const isLoggedIn = localStorage.getItem("loggedInAdmin");

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}
